import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useCurrencyFormat } from '../../hooks/useCurrencyFormat';
import { useTranslation } from '../../hooks/useTranslation';
import { calculateTotals } from '../utils/calculateTotals';

export const OrderTotalField: React.FC = () => {
  const { watch } = useFormContext();
  const { formatCurrency } = useCurrencyFormat();
  const { translate } = useTranslation();

  const formData = watch();
  const { totalExTaxes, discount, total } = calculateTotals(formData);

  return (
    <div className="text-right space-y-1">
      <div className="text-sm text-muted-foreground flex justify-between">
        <span>{translate('pos.orders.fields.totalBeforeDiscount')}</span>
        <span>
          <span data-sensitive-field="amount">
            {formatCurrency(totalExTaxes)}
          </span>
        </span>
      </div>
      {discount > 0 && (
        <div className="text-sm text-destructive flex justify-between">
          <span>{translate('pos.orders.fields.discount')}</span>
          <span>
            -
            <span data-sensitive-field="amount">
              {formatCurrency(discount)}
            </span>
          </span>
        </div>
      )}
      <div className="border-t border-border pt-2 mt-2 flex justify-between items-center">
        <span className="text-sm font-medium">
          {translate('pos.orders.fields.totalAfterDiscount')}
        </span>
        <span className="text-2xl font-bold text-green-600 dark:text-green-400">
          <span data-sensitive-field="amount">{formatCurrency(total)}</span>
        </span>
      </div>
    </div>
  );
};
